import { PackageVariantClosedMinusIcon } from './PackageVariantClosedMinusIcon';

/**
 * author: Ferenc Szabo
 * id DF9F88A2-7B9A-4881-A2E4-6BC6F4387A0F
 * name package-variant-closed-minus
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-closed-minus.svg
 * tags
 */
export const PackageVariantClosedSubtractIcon = PackageVariantClosedMinusIcon;
export default PackageVariantClosedSubtractIcon